/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Replyplaceholder2Inputs */

const en_coinvestments_messages_replyplaceholder2 = /** @type {(inputs: Coinvestments_Messages_Replyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type your reply...`)
};

/**
* | output |
* | --- |
* | "Type your reply..." |
*
* @param {Coinvestments_Messages_Replyplaceholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_replyplaceholder2 = /** @type {((inputs?: Coinvestments_Messages_Replyplaceholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Replyplaceholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_replyplaceholder2(inputs)
});
export { coinvestments_messages_replyplaceholder2 as "coInvestments_messages_replyPlaceholder" }